module.exports = __webpack_public_path__ + "img/03.175939c6.png";